import { useEffect, useMemo } from 'react'
import { useInView } from 'react-intersection-observer'
import { fetchProperty } from 'actions/PropertyActions'
import { useAppDispatch, useAppSelector } from 'hooks/reduxHooks'
import { mapPropertyPopularFacilitiesToAmenities } from 'components/SearchKit/SearchTiles/accommodations/propertyPopularFacilities'
import useOfferMetaData from './useOfferMetaData'

function useOfferCardFacilities(
  offerId: string,
  filters: App.OfferListFilters | undefined,
  fallbackFacilities: Array<App.OfferInclusion>,
) {
  const metaData = useOfferMetaData(offerId, filters)
  const propertyId = metaData?.accommodationId
  const property = useAppSelector(state => propertyId ? state.offer.properties[propertyId]?.property : undefined)
  const dispatch = useAppDispatch()
  const [ref, inView] = useInView({ triggerOnce: true })

  useEffect(() => {
    if (inView && propertyId) dispatch(fetchProperty(propertyId))
  }, [dispatch, inView, propertyId])
  const facilities = useMemo<Array<App.OfferInclusion>>(() => {
    return property?.popularFacilities.length
      ? mapPropertyPopularFacilitiesToAmenities(property.popularFacilities)
      : fallbackFacilities
  }, [fallbackFacilities, property?.popularFacilities])

  return { facilities, ref }
}

export default useOfferCardFacilities
